import type { FC, ReactNode } from 'react'
export const Header: FC<{ children?: ReactNode }> = () => null
